import { SxProps } from '@mui/material';

export const FullPageSpinnerRingStyles: SxProps = {
  alignItems: 'center',
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  overflow: 'auto',
  width: '100%',
};
export const FullPageSpinnerRingInnerStyles: SxProps = {
  animation: '$rotate 1.2s linear infinite',
  border: '5px solid #3f51b5',
  borderColor: '#3f51b5 transparent #3f51b5 transparent',
  borderRadius: '50%',
  display: 'block',
  height: 92,
  margin: 1,
  width: 92,
};
